import axios from 'axios';

const getApiKey = async () => {
  const apiKeyArray = [
    'HUYMU48KEGUYKVA6',
    '2LWLYANUANIP57QX',
    'INTSI1NH50H6HLCF',
  ];
  const randomIndex = Math.floor(Math.random() * apiKeyArray.length);
  return apiKeyArray[randomIndex];
};

const GetCompanyData = async (ticker) => {
  const apiKey = await getApiKey();
  const data = axios
    .get(
      `https://www.alphavantage.co/query?function=NEWS_SENTIMENT&tickers=${ticker}&limit=50&apikey=${apiKey}`
    )
    .then((response) => {
      const filteredFeed = response.data.feed.filter((item) => {
        return item.ticker_sentiment.some((sentiment) => {
          return (
            sentiment.ticker === ticker &&
            parseFloat(sentiment.relevance_score) > 0.3
          );
        });
      });
      return filteredFeed;
    })
    .catch((error) => {
      console.error(error);
    });
  return data;
};

export default GetCompanyData;
